import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class CategorySubRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/product_sub_categories');
    }

    async getAll() {
        // if (Cache.get('product-categories-sub')) {
        //     return Cache.get('product-categories-sub');
        // }

        return this.where('per_page', 1000).run().then((res) => {
            Cache.set('product-categories-sub', res.data, 60 * 15 * 1000);
            return Cache.get('product-categories-sub');
        });
    }
}
